import { useEffect, useState } from 'react';
import { get_all_role } from 'services/auth/permission';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import BaseTextField from 'general/custom-fields/BaseTextField';
import { t } from 'i18next';
import * as Yup from 'yup';

Modal_AddUser.propTypes = {
  onSubmit: PropTypes.func,
};

Modal_AddUser.defaultProps = {
  onSubmit: null,
};

function Modal_AddUser(props) {
  const { initialValues, onSubmit, dismiss } = props;
  const [selectedOption, setSelectedOption] = useState({});
  const [roles, set_Roles] = useState([]);

  const [onSave, setOnSave] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const roles = await get_all_role();
      set_Roles(roles.data.data);
      // setSelectedOption(roles.data.data[0]);
    };
    fetchData();
  }, []);

  const validationSchema = Yup.object().shape({
    // username: Yup.string().email(t('EmailNotValid')).required(t('EmailIsRequired')),
    password: Yup.string().trim().required(t('PasswordIsRequired')),
    username: Yup.string().trim().required(t('AccountIsRequired')),
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) => {
        if (selectedOption?.roleId) {
          onSubmit({ ...values, roleId: selectedOption.roleId }, actions);
          dismiss();
        }
        setOnSave(true);
      }}
      validationSchema={validationSchema}
    >
      {(formikProps) => {
        const { values, errors, touched, isSubmitting } = formikProps;

        return (
          <Form>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  <b>Thêm người dùng</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => dismiss()}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="username"
                      label={'Tên đăng nhập'}
                      placeholder={`Nhập tên đăng nhập...`}
                      component={BaseTextField}
                      asterisk="true"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="email"
                      label={'Email'}
                      component={BaseTextField}
                      placeholder={`Email...`}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="fullname"
                      label={'Họ tên'}
                      component={BaseTextField}
                      placeholder={`Họ tên...`}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="phone"
                      label={'Số điện thoại'}
                      placeholder={`Số điện thoại...`}
                      component={BaseTextField}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <div className="d-flex justify-content-between align-items-start">
                        <label htmlFor="chooseRange" className="font-weight-bolder">
                          Vai trò <b className="text-danger">(*)</b>
                        </label>
                      </div>
                      <div className="KeenSelectOption">
                        <div className="w-100">
                          <div className="dropdown">
                            <button
                              type="button"
                              id="chooseRange"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              className="w-100 cursor-pointer border shadow-none d-flex align-items-center justify-content-between dropdown-toggle btn"
                            >
                              {selectedOption?.name ?? 'Chọn vai trò'}
                            </button>
                            <ul className="dropdown-menu w-100" aria-labelledby="chooseRange">
                              {roles.map((option, index) => (
                                <span
                                  key={index}
                                  className={`dropdown-item border-bottom ${
                                    selectedOption.name == option.name ? 'text-primary' : ''
                                  }`}
                                  style={{
                                    borderTop: '1px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                  onClick={() => setSelectedOption(option)}
                                >
                                  <span>{option.name}</span>
                                  {selectedOption == option && (
                                    <div className="d-flex align-items-center justify-content-end">
                                      <i
                                        className="fa fa-check text-primary"
                                        style={{ fontSize: '10px' }}
                                      ></i>
                                    </div>
                                  )}
                                </span>
                              ))}
                            </ul>
                            {!selectedOption?.roleId && onSave == false ? null : (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">Chưa chọn quyền</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="password"
                      label={`Mật khẩu`}
                      placeholder={`Mật khẩu...`}
                      component={BaseTextField}
                      asterisk="true"
                      type="password"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => dismiss()}
                >
                  Hủy bỏ
                </button>
                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                  Thêm
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Modal_AddUser;
